export default "__VITE_ASSET__DhGnf6ZM__"